import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import LabelValue from '../../LabelValue';
import { Driver } from '../../../data/models/driver.model';
import { useBooleanStatus } from '../../../hooks/useBooleanStatus';
import { useActiveStatus } from '../../../hooks/useActiveStatus';
import { useFormatDate } from '../../../hooks/useFormatDate';
import { useState } from '../../../hooks/useState';
import LabelLink from '../../LabelLink';
import { FULLSTORY_MASK_CLASSNAME } from '../../../services/analyticsUtils';

interface TransportationInfoProps {
  driver: Driver | null;
}

export default function TransportationInfo(props: TransportationInfoProps) {
  const { t } = useTranslation('common');
  const { driver } = props;

  return (
    <>
      <Grid container spacing={2}>
        <Grid item lg={3} md={6} sm={12}>
          <LabelLink
            label={t('common.provider')}
            value={driver?.transportationProvider?.transportationProviderName}
            link={`/providers/${driver?.transportationProviderID}`}
            underline="always"
          />
        </Grid>
        <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            className={FULLSTORY_MASK_CLASSNAME}
            label={t('driver.dlNumber')}
            value={driver?.driversLicenseNumber}
          />
        </Grid>
        <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            label={t('driver.dlState')}
            value={useState(driver?.driverLicenseIssuedInStateCode)}
          />
        </Grid>
        <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            label={t('driver.dateOfBirth')}
            value={useFormatDate(driver?.driverDateOfBirth)}
          />
        </Grid>
        <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            label={t('common.status')}
            value={useActiveStatus(driver?.driverState)}
          />
        </Grid>
        <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            label={t('common.clearToTransport')}
            value={useBooleanStatus(driver?.isClearToTransport)}
          />
        </Grid>
        {/* <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            label={t('driver.lastLogin')}
            value={
              driver?.userAccountDriver?.userAccount.lastLoggedInOnUTC || ''
            }
          />
        </Grid> */}
      </Grid>
    </>
  );
}
